<script setup>
import { onMounted, onUnmounted, ref } from "vue";

import SvgIcon from "./SvgIcon.vue";

const props = defineProps({
  size: { type: String, default: "16" },
  delayed: { type: Boolean, default: false },
  delayDuration: { type: Number, default: 300 },
});

const visible = ref(!props.delayed);
let timer;

onMounted(() => {
  if (props.delayed) {
    timer = setTimeout(() => {
      visible.value = true;
    }, props.delayDuration);
  }
});

onUnmounted(() => clearTimeout(timer));
</script>

<template>
  <SvgIcon
    v-if="visible"
    class="base-spinner"
    name="system/loader"
    :width="size"
    :height="size"
    aria-hidden="true"
  />
</template>

<style lang="scss" scoped>
.base-spinner {
  flex-shrink: 0;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
